import { LiveAnnouncer } from '@angular/cdk/a11y'
import { COMMA, ENTER } from '@angular/cdk/keycodes'
import { CommonModule } from '@angular/common'
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core'
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete'
import { RouterModule } from '@angular/router'
import { Observable, Subscription } from 'rxjs'
import { map, startWith } from 'rxjs/operators'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'

@Component({
  selector: 'ddc-elem-chooser-one',
  templateUrl: './ddc-elem-chooser-one.component.html',
  styleUrls: ['./ddc-elem-chooser-one.component.scss'],
  imports: [AngularMaterialsModules, CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
})
export class DdcElemChooserOneComponent implements OnInit {
  @Input() _label: string
  @Input() _labelIcon: string
  @Input() _placeholder: string
  @Input() _allElems: { id: number; label: string }[]
  @Input() _defaultElem: { id: number; label: string }
  @Input() _defaultElems: { id: number; label: string; rawValue?: string }[]
  @Input() _type: string // single, multi
  @Input() _elemType: string // tag, cat , ...

  @Output() selectedElemsChange = new EventEmitter<{ id: number; label: string }[]>()

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  _isTag: boolean = false
  _isDic: boolean = false
  private themeSubscription: Subscription

  _languageMode: boolean = false

  separatorKeysCodes: number[] = [ENTER, COMMA]
  elemCtrl = new FormControl('')
  filteredElems: Observable<{ id: number; label: string }[]>
  elems: { id: number; label: string }[] = []
  typedOption = ''

  @ViewChild('elemInput') elemInput: ElementRef<HTMLInputElement>

  announcer = inject(LiveAnnouncer)

  constructor(
    private logger: DdcLoggerService,
    public themeService: ThemeService,
  ) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
    // if (this._defaultElem) this._allElems.push(this._defaultElem)
    // if (this._defaultElem) this.filteredElems.push(this._defaultElem)
    this.filteredElems = this.elemCtrl.valueChanges.pipe(
      startWith(null),
      map((elem: string | null) => (elem ? this._filter(elem) : this._allElems.slice())),
    )
  }

  ngOnInit(): void {
    if (this._elemType == 'tag') this._isTag = true
    else if (this._elemType == 'dictionary') this._isDic = true

    if (this._defaultElem) this.elems.push(this._defaultElem)

    if (this._defaultElems && this._defaultElems.length > 0) {
      this.elems = this.elems.concat(this._defaultElems)
    }

    if (this._type == 'fav-languages') this._languageMode = true
  }

  // Function to emit the updated list of selected elems
  emitSelectedElems(): void {
    this.selectedElemsChange.emit(this.elems)
  }

  removeElem(elem: { id: number; label: string }): void {
    const index = this.elems.findIndex(e => e.id === elem.id && e.label === elem.label)

    if (index >= 0) {
      this.elems.splice(index, 1)
      this.announcer.announce(`Removed ${elem.label} with ID ${elem.id}`)
    }

    this.emitSelectedElems()
  }

  optionSelected(event: MatAutocompleteSelectedEvent): void {
    //remove (Add New)
    var selectedOption = event.option.viewValue
    const addNewStr = ' (Add New)'
    if (
      !this._allElems.some(elem => elem.label === event.option.viewValue) &&
      event.option.viewValue.includes(addNewStr)
    ) {
      selectedOption = selectedOption.replace(addNewStr, '')
    }

    if (this._type === 'single') {
      this.elems = []
    }
    if (!this.elems.some(elem => elem.label === selectedOption)) {
      this.elems.push({ id: 0, label: selectedOption })
    }
    this.elemInput.nativeElement.value = ''
    this.elemCtrl.setValue(null)
    this.emitSelectedElems()
  }

  private _filter(value: string): { id: number; label: string }[] {
    const filterValue = value.toLowerCase()
    return this._allElems.filter(elem => elem.label.toLowerCase().includes(filterValue))
  }

  shouldShowAddNewOption(): boolean {
    return this.typedOption && !this._allElems.some(elem => elem.label === this.typedOption)
  }
}
